/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {simSelectAnimations as ɵa} from './select-animations';